module.exports = __webpack_public_path__ + "media/images/menu-icons/make-d20c77df72cf1b10b90ed3f8a2ea7d31.svg";